const defaultLangKey = 'sv';
const langs = [defaultLangKey, 'en'];

module.exports = {
  langs,
  defaultLangKey,
};
